import { render } from "./AgreeEdit.vue?vue&type=template&id=fbc7901e"
import script from "./AgreeEdit.vue?vue&type=script&lang=js"
export * from "./AgreeEdit.vue?vue&type=script&lang=js"

import "./AgreeEdit.vue?vue&type=style&index=0&id=fbc7901e&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__